import { render, staticRenderFns } from "./InvoiceRecord.vue?vue&type=template&id=215bda04&scoped=true"
import script from "./InvoiceRecord.vue?vue&type=script&lang=js"
export * from "./InvoiceRecord.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecord.vue?vue&type=style&index=0&id=215bda04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215bda04",
  null
  
)

export default component.exports